import { render, staticRenderFns } from "./UcRentalGeneralPanel.yaml?vue&type=template&id=aa56567a&component"
import script from "./UcRentalGeneralPanel.yaml?vue&type=script&lang=ts&component"
export * from "./UcRentalGeneralPanel.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports